<template>
  <q-toolbar-title class="two-tier-toolbar" @click="$emit('click')">
    <transition name="slideTransitionSmall">
      <div
        v-if="!!$slots.subtitle"
        class="subtitle"
      >
        <slot name="subtitle" />
      </div>
    </transition>
    <slot />
  </q-toolbar-title>
</template>

<script>
/**
 * PageToolbarTitle works in a similar fashion to the default QToolbarTitle,
 * however it supports a subtitle above the main title
 *
 * SLOTS:
 * - subtitle: subtitle text to display
 * - default: main text slot
 */
export default {
  emits: ['click']
}
</script>
